var _defs, _path, _path2, _rect, _path3, _path4, _path5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a8e9b69f-d0cd-40c2-9873-9fd187fdf757",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b104819c-319d-4546-ae67-a18489294eca,.b465d438-5b05-4d62-a795-475e279d7cf7{fill:none;}.b104819c-319d-4546-ae67-a18489294eca,.b7514cde-0c1e-42b5-b918-a95dafd3427d{stroke:#8e8e8e;}.b104819c-319d-4546-ae67-a18489294eca,.b465d438-5b05-4d62-a795-475e279d7cf7,.b7514cde-0c1e-42b5-b918-a95dafd3427d{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.a94f6e7e-d39d-481f-8a81-37d82415bb74,.b7514cde-0c1e-42b5-b918-a95dafd3427d{fill:#1495c1;}.bf68d2a0-65e1-49c0-abcd-f1284f2a6174{fill:#fff;}.b465d438-5b05-4d62-a795-475e279d7cf7{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "zip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b104819c-319d-4546-ae67-a18489294eca",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b7514cde-0c1e-42b5-b918-a95dafd3427d",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a94f6e7e-d39d-481f-8a81-37d82415bb74",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bf68d2a0-65e1-49c0-abcd-f1284f2a6174",
    d: "M45.3,71.6l5.6-8.2H45.8V62.2h6.8V63L47,71.2h5.7v1.1H45.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bf68d2a0-65e1-49c0-abcd-f1284f2a6174",
    d: "M55.6,62.2V72.3H54.3V62.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "bf68d2a0-65e1-49c0-abcd-f1284f2a6174",
    d: "M57.9,62.3h2.5a4.3,4.3,0,0,1,2.8.8,2.6,2.6,0,0,1,.9,2.1,3.3,3.3,0,0,1-.8,2.2,4.3,4.3,0,0,1-3.1,1.1h-1v4H57.9Zm1.3,4.9h1c1.6,0,2.6-.7,2.6-2.1s-1-2-2.4-2H59.2Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 32,
    y1: 42.7,
    x2: 32,
    y2: 45.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 37.8,
    y1: 42.7,
    x2: 37.8,
    y2: 45.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 43.6,
    y1: 42.7,
    x2: 43.6,
    y2: 45.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 49.4,
    y1: 42.7,
    x2: 49.4,
    y2: 45.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 55.2,
    y1: 42.7,
    x2: 55.2,
    y2: 45.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 61,
    y1: 42.7,
    x2: 61,
    y2: 45.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 34.9,
    y1: 39.7,
    x2: 34.9,
    y2: 42.7
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 40.7,
    y1: 39.7,
    x2: 40.7,
    y2: 42.7
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 46.5,
    y1: 39.7,
    x2: 46.5,
    y2: 42.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 52.3,
    y1: 39.7,
    x2: 52.3,
    y2: 42.7
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 58.1,
    y1: 39.7,
    x2: 58.1,
    y2: 42.7
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "b465d438-5b05-4d62-a795-475e279d7cf7",
    x1: 32,
    y1: 42.7,
    x2: 61,
    y2: 42.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.3e36c57ceaf143cd7a239dfffae33885.svg";
export { ForwardRef as ReactComponent };